import {v4 as uuidv4} from 'uuid';
import * as _ from 'lodash'

export const MOBILE_REGEX = /^(09)\d{9}$/;

export function getErrorMessage({message, type}) {
  // console.log(type)
  if (message) return message;
  if (type === 'required') {
    return 'required'
  }
  if (type === 'pattern') {
    return 'wrong format'
  }
}

export function getErrorProps (errors, key, type) {
  const d = _.get(errors, key)
  return {
    error: Boolean(d),
    helperText: d && getErrorMessage(d)
  }
}

export function getItemErrorProps (errors, key, type) {
  if (!type || type === 'text' || type === 'number' || type === 'select') {
    return {}
  }

  return {
    error: Boolean(errors[key]),
    helperText: errors[key] && getErrorMessage(errors[key].message || errors[key].type)
  }
}
export function getFieldProps (name) {
  return {
    label: name,
    placeholder: name,
    variant: 'outlined',
    size: 'small',

  }
}

const UUIDRegex = /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/g;
export function getFormModAndID() {

  let mod = 'add';
  let uuid = uuidv4();
  if (window.location.pathname.indexOf('/edit') > -1) {
    mod = 'edit';
    uuid = window.location.pathname.split('edit/')[1]
  }
  else if (window.location.pathname.indexOf('/view') > -1) {
    // mod = 'view';
    const matches = window.location.pathname.match(UUIDRegex)
    uuid = matches[matches.length - 1]
    // uuid = window.location.pathname.split('view/')[1]
  }
  return {mod, uuid}
}

export function getDescendantProp(obj, desc) {
  const arr = desc.split(".");
  while(arr.length && (obj = obj[arr.shift()]));
  return obj;
}